import { Component, OnInit, Input } from '@angular/core'
import { ResourceGroup, ResourceType, Resource } from '@mprep/shared/data/models'
import { ResourceGroupService, NavigationService } from 'app/shared/services'

const PLACEHOLDER_LAUNCH_TEXT = 'Coming Soon'
const PLACEHOLDER_RESOURCE_TYPE = ResourceType.Placeholder

@Component({
  selector: 'mp-resource-groups',
  templateUrl: './resource-groups.html',
  styleUrls: ['./resource-groups.scss']
})
export class ResourceGroupsComponent implements OnInit {
  @Input() public resourceGroups: ResourceGroup[] = []
  @Input() public resourceType: ResourceType

  private _resourceGroupsConfig: object

  constructor(private _resourceGroupService: ResourceGroupService, private _navigationService: NavigationService) {
    this._resourceGroupsConfig = {}

    this._resourceGroupsConfig[ResourceType.Ebook] = {
      categories: [5, 7],
      iconClass: 'fa fa-book',
      launchText: 'Download'
    }

    this._resourceGroupsConfig[ResourceType.Video] = {
      categories: [2, 3, 4],
      iconClass: 'fa fa-play',
      launchText: 'Open'
    }

    this._resourceGroupsConfig[ResourceType.Pdf] = {
      categories: [6, 8],
      iconClass: 'fa fa-download',
      launchText: 'Open'
    }

    this._resourceGroupsConfig[ResourceType.OgExam] = {
      categories: [10],
      iconClass: 'fa fa-desktop',
      launchText: 'Take'
    }

    this._resourceGroupsConfig[ResourceType.Exam] = {
      categories: [11],
      iconClass: 'fa fa-desktop',
      launchText: 'Take'
    }
  }

  public ngOnInit() {
    this._resourceGroupService
      .findModelsBy({ category_id: this._getCagetories() }, ['resources'])
      .subscribe((groups: ResourceGroup[]) => {
        this.resourceGroups = groups
      })
  }

  public get iconClass(): string {
    return this._resourceGroupsConfig[this.resourceType].iconClass
  }

  public launchText(resource: Resource): string {
    return resource.resourceType === PLACEHOLDER_RESOURCE_TYPE
      ? PLACEHOLDER_LAUNCH_TEXT
      : this._resourceGroupsConfig[this.resourceType].launchText
  }

  public launchResource(resource: Resource) {
    if (resource.resourceType === PLACEHOLDER_RESOURCE_TYPE) return
    this._navigationService.navigateToResource(resource)
  }

  private _getCagetories(): number {
    return this._resourceGroupsConfig[this.resourceType].categories
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/resource-groups/resource-groups.component.ts